export default [
  {
    path: process.env.IS_LOCAL === 'true' ? '' : '' + `/license`,
    name: "License",
    component: () => import("@/pages/Organization/Forms2-4/form3License"),
    meta: {
      title: "Сведения о лицензиях",
    },
  },
  {
    path: process.env.IS_LOCAL === 'true' ? '' : '' + `/accreditation`,
    name: "Accreditation",
    component: () => import("@/pages/Organization/Forms2-4/form4Accreditation"),
    meta: {
      title: "Аккредитации организации",
    },
  },
  {
    path: process.env.IS_LOCAL === 'true' ? '' : '' + `/offers`,
    name: "Offers",
    component: () => import("@/pages/Organization/Forms2-4/form2Offers"),
    meta: {
      title: "Предложения по КЦП",
    },
  },
  {
    path: process.env.IS_LOCAL === 'true' ? '' : '' + "/indicators",
    component: () => import("@/layouts/simpleLayout"),
    meta: {},
    children: [
      {
        path: "",
        name: "AllList",
        component: () => import("@/pages/Organization/kcpBalls/allList"),
        meta: {
          title: "Сводные оценки заявок",
        },
        props: true,
        needProfileData: true,
      },
      {
        path: "details",
        component: () => import("@/pages/Organization/kcpBalls/fullInfo"),
        meta: {
          title: "",
        },
        props: true,
      },
      {
        path: "stage-1",
        name: "AllListStage1",
        component: () => import("@/pages/Organization/kcpBalls/allListStage1"),
        meta: {
          title: "Распределение КЦП на 2025/26 учебный год",
        },
        props: true,
      },
      {
        path: "stage-1_correctValues",
        name: "AllListStage1CorrectValues",
        component: () => import("@/pages/Organization/kcpBalls/allListStage1CorrectValues"),
        meta: {
          title: "Распределение КЦП на 2025/26 учебный год",
        },
        props: true,
      },
      {
        path: "region",
        name: "AllListRegion",
        component: () => import("@/pages/Organization/kcpBalls/allListRegion"),
        meta: {
          title: "Объемы КЦП в регионе на 2025/26 учебный год",
        },
        props: true,
      },
      {
        path: "stage-1_region",
        name: "AllListStage1Region",
        component: () => import("@/pages/Organization/kcpBalls/allListStage1Region"),
        meta: {
          title: "Объемы КЦП в регионе на 2025/26 учебный год",
        },
        props: true,
      },
    ],
  },
  {
    path: process.env.IS_LOCAL === 'true' ? '' : '' + "/form-a",
    name: "FormA",
    component: () => import("@/pages/Organization/dopForms/formA-G"),
    meta: {
      title: "Дополнительные данные",
    },
    props: true,
  },
  {
    path: process.env.IS_LOCAL === 'true' ? '' : '' + "/form-b",
    name: "FormB",
    component: () => import("@/pages/Organization/dopForms/formA-G"),
    meta: {
      title: "Дополнительные данные",
    },
    props: true,
  },
  {
    path: process.env.IS_LOCAL === 'true' ? '' : '' + "/form-v",
    name: "FormV",
    component: () => import("@/pages/Organization/dopForms/formA-G"),
    meta: {
      title: "Дополнительные данные",
    },
    props: true,
  },
  {
    path: process.env.IS_LOCAL === 'true' ? '' : '' + "/form-g",
    name: "FormG",
    component: () => import("@/pages/Organization/dopForms/formA-G"),
    meta: {
      title: "Дополнительные данные",
    },
    props: true,
  },
  {
    path: process.env.IS_LOCAL === 'true' ? '' : '' + "/block-print",
    name: "BlockPrintOrganization",
    component: () => import("@/pages/Organization/BlockPrint"),
    meta: {
      title: "Блокировка и отправка конверта",
    },
    props: true,
  },
  {
    path: process.env.IS_LOCAL === 'true' ? '' : '' + "/forms",
    component: () => import("@/layouts/simpleLayout"),
    meta: {
      title: "Показатели деятельности",
      roles: ["ADMIN_ROLE", "ORGANIZATION_ROLE"],
    },
    children: [
      {
        path: "",
        name: "FormList",
        component: () => import("@/pages/Organization/Forms5/ListForms"),
        meta: {
          title: "Показатели деятельности образовательной организации",
          roles: ["ADMIN_ROLE", "ORGANIZATION_ROLE"],
        },
        props: true,
      },
      {
        path: ":form_id",
        name: "Forms",
        component: () => import("@/pages/Organization/Forms5/allFifthForms"),
        meta: {
          title: "",
          roles: ["ADMIN_ROLE", "ORGANIZATION_ROLE"],
        },
        props: true,
      },
    ],
  },
].map((el) => ({
  ...el,
  meta: {
    ...el.meta,
    adminNeedAsOrgAuth: true,
    needContact: true,
    roles: ["ADMIN_ROLE", "ORGANIZATION_ROLE"],
  },
}));
